interface GetBalanceEmptyStateKeyOptions {
  activeFilterCount: number
  search: string
}

// Side-relative i18n key (resolved through `bt`) for an overview table that came back with no rows.
export const getBalanceEmptyStateKey = (options: GetBalanceEmptyStateKeyOptions): string => {
  const { activeFilterCount, search } = options

  if (search) {
    return 'empty_state.no_accounts_search'
  }

  if (activeFilterCount > 0) {
    return 'table.empty_filtered'
  }

  return 'empty_state.no_entries_for_period'
}
